import { Position } from '@deck.gl/core/typed/types/layer-props';
import { PlannerMapDataElement } from 'components/common/types/Planner.types';

export const getMapElementPosition = (data: PlannerMapDataElement): Position => {
  return data.geometry.coordinates;
};
